<template>
    <span>
        <el-button @click="bindArea" type="primary">绑定渠道</el-button>
        <el-dialog title="选择绑定渠道" :visible.sync="dialogFormVisible" @opened="setChecked">
            <el-form :model="form">
                <el-form-item>
                    <el-input
                        placeholder="输入关键字进行过滤"
                        v-model="filterText"
                        style="width:80%"
                        >
                    </el-input>&nbsp;&nbsp;&nbsp;<el-checkbox v-model="selectAll">全选</el-checkbox>
                </el-form-item>
                <el-form-item style="height: 500px; overflow-y: auto">
                    <el-tree
                        class="filter-tree"
                        :data="list"
                        :props="defaultProps"
                        :filter-node-method="filterNode"
                        show-checkbox
                        node-key="id"
                        highlight-current
                        ref="tree">
                    </el-tree>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save" :loading="loading">确 定</el-button>
            </div>
        </el-dialog>
    </span>
</template>
<style scoped>

</style>
<script>
    import SaleChannelService from "~/services/SaleChannel";
    export default {
        name: "channelTree",

        components: {
        },

        props: {
            checked_ids: {
                type: Array,
                default: function () {
                    return [];
                }
            },
        },

        data() {
            return {
                list: [],
                loading: false, 
                defaultProps: {
                    children: 'children',
                    label: 'name',
                    key: 'id'
                },
                dialogFormVisible: false,
                filterText: '',
                form: {},
                selectAll: false
            };
        },

        mounted() {

        },

        created: function () {
            this.getList();
        },
        watch: {
            filterText(val) {
                this.$refs.tree.filter(val);
            },

            selectAll(newValue) {
                this.$nextTick(() => {
                    const tree = this.$refs.tree;
                    if (tree) {
                        const allKeys = this.getAllNodeKeys(this.list);
                        if (newValue) {
                            tree.setCheckedKeys(allKeys);
                        } else {
                            tree.setCheckedKeys([]);
                        }
                    }
                });
            }
        },
        methods: {
            bindArea(){
                this.dialogFormVisible = true;
                this.selectAll = false;
                this.filterText = '';
            },

            setChecked(){
                this.$refs.tree.setCheckedKeys(this.checked_ids);
            },

            getList(){
                this.loading = true;
                SaleChannelService.getTreeList({}).then(res => {
                    if (res.code == 0 && res.data) {
                        this.list = res.data
                    }
                    this.loading = false;
                }).catch(err => {
                  this.loading = false;
                  console.error(err);
                });
            },

            filterNode(value, data) {
                if (!value) return true;
                return data.name.indexOf(value) !== -1;
            },

            save() {
                const ids = this.$refs.tree.getCheckedKeys();
                if(ids.length == 0){
                    this.$message({
                        message: '请先勾选渠道',
                        type: 'error'
                    });
                    return false;
                }
                this.loading = true;
                SaleChannelService.getChannels(ids).then(res => {
                    if (res.code == 0 && res.data.length > 0) {
                        this.$emit("change", res.data);
                        this.dialogFormVisible = false;
                    }else{
                        this.$message({
                            message: '渠道识别失败！',
                            type: 'error'
                        });
                    }
                    this.loading = false;
                }).catch(err => {
                  this.loading = false;
                  console.error(err);
                });
            },

            getAllNodeKeys(nodes) {
                return nodes.reduce((keys, node) => {
                    keys.push(node[this.defaultProps.key]);
                    if (node.children && node.children.length > 0) {
                        keys = keys.concat(this.getAllNodeKeys(node.children));
                    }
                    return keys;
                }, []);
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/views/user/dialog/channelTree.vue